module.exports = __webpack_public_path__ + "static/media/0024_IMG_TRAD_LES_MURS_BARDAGE_BOIS_HORIZONTAL.979fcc9b.png";